module.exports = __webpack_public_path__ + "static/media/47-portland.079dcd83.jpeg";